import React, { FC } from 'react'

interface Props {
  member: { id: number, name: string, profile_image: string | null }
}

const MemberContentsHeader: FC<Props> = (props) => {
  const { member } = props

  return (
    <>
      {
        !!member.id && (
          <>
            <div style={{ textAlign: "center", marginTop: "1.5em", marginBottom: "1.5em" }}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img
                  alt=""
                  src={member?.profile_image ?? `/static/images/profile/${(Number(member.id) || 0) % 12}.jpeg`}
                  className="profile_icon"
                  style={{ width: "40px", height: "40px" }}
                />
                <span style={{ fontSize: "32px", fontWeight: "bold", color: "#094E8D" }}>
                  {member.name}
                </span>
              </div>
            </div>
          </>
        )
      }
    </>
  )
}

export default MemberContentsHeader
